var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cgx } from "@springcare/dsm";
export var colors = __assign(__assign({}, cgx.colors), { 
    // overrides for color schemes
    base: cgx.colors.spring, positive: cgx.colors.green, negative: cgx.colors.red, warning: cgx.colors.yellow, info: cgx.colors.blue });
